import React from 'react';
import { NextSeo } from 'next-seo';
import nookies from 'nookies';
import { useUserAgent } from 'next-useragent';
import { RootStoreProvider } from '../../providers/RootStoreProvider';
import { Layout } from '../../components/Layout';
import { BreadCrumbs } from '../../components/BreadCrumbs';
import { apiProxy } from '../../lib/api';
import { SearchStoreProvider } from '../../providers/SearchStoreProvider';
import { BlogPostPage } from '../../components/BlogPage';
import { logger } from '../../lib/logger';
import { containsSea } from '../../utils/containSea';

export default function BlogPage({
  uaString,
  store: { user, banners, article, popularPopdirs },
  canonicalUrl,
}) {
  const ua = useUserAgent(uaString || window.navigator.userAgent);
  const { isMobile, isTablet } = ua;
  const pageRoute = [
    { title: 'Блог', link: '/blog' },
    { title: article.title, link: '' },
  ];
  return (
    <SearchStoreProvider hydrationData={{ user, article }}>
      <RootStoreProvider hydrationData={{ user, article }}>
        <NextSeo
          title={`${String(article?.seo_title)} | Блог Круиз.онлайн`}
          description={String(article?.seo_description)}
          // openGraphTitle={String(article?.seo_title)}
          openGraph={{
            // url: 'https://www.url.ie/a',
            title: String(article?.seo_title),
            description: String(article?.seo_description),
            siteName: 'Круиз Онлайн',
          }}
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: '/favicon.ico?v=2',
            },
          ]}
          canonical={canonicalUrl}
        />
        <Layout
          isAdvertising
          isMobile={isMobile}
          isTablet={isTablet}
          isContact
          isBlog
          popularPopdirs={popularPopdirs}
        >
          <div className="container--block">
            <div>
              <BreadCrumbs routeCrumbs={pageRoute} />
            </div>
            <BlogPostPage
              isMobile={isMobile}
              isTablet={isTablet}
              banners={banners}
            />
          </div>
        </Layout>
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}
export const getServerSideProps = async ctx => {
  const cookies = nookies.get(ctx);
  const { token } = cookies;

  // Получаем только путь без query параметров
  const canonicalPath = ctx.req.url.split('?')[0];
  const canonicalUrl = `https://kruiz.online${canonicalPath}`;
  const hasSea = containsSea(ctx.req.url);
  try {
    const responses = await Promise.allSettled([
      apiProxy.get(`ApiUsers/check_token/${token ?? ''}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
      apiProxy.get('ApiBanners/getHomepageBanners?is_sea=0', {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
      apiProxy.get(`ApiBlog/get_post/${ctx.params.id}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
      apiProxy.get(`ApiPopdirNew/getHeaderPopdir/${hasSea}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
    ]);

    const [user, banners, article, popularPopdirs] = responses.map(req =>
      req.status === 'fulfilled' ? req.value.data ?? null : null,
    );
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      level: 'debug',
      ym_uid: cookies._ym_uid,
      message: 'page has been created',
    });
    return {
      props: {
        store: {
          user,
          banners,
          article,
          popularPopdirs,
        },
        uaString: ctx.req.headers['user-agent'],
        canonicalUrl,
      },
    };
  } catch (error) {
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      error,
      level: 'error',
      message: 'page was not created',
    });
    return {
      redirect: {
        destination: '/503',
        permanent: true,
      },
    };
  }
};
